import ACTIONS from '@/store/storeActions';
import RunDetailsRestModel from '@/api/RestModels/run';
import LoadingState from '@/api/LoadingState';

export default class Run {
  constructor(store) {
    this.$store = store;
  }

  /**
   * @param [pathExtension]
   * @return {Promise<unknown>}
   */
  async get(pathExtension = undefined) {
    // set LoadingState to Loading
    this.$store.dispatch(ACTIONS.SET_RUN_INFO_LOADINGSTATE, { type: 'runInfo', loadingState: LoadingState.LOADING })
    try {
      // fetch runDetails
      const runDetails = await RunDetailsRestModel.get(pathExtension);
      // set runDetails and all resulting data entries
      this.$store.dispatch(ACTIONS.SET_RUN_INFO, runDetails);

      // if no error occures, set LoadingState to LOADED
      this.$store.dispatch(ACTIONS.SET_RUN_INFO_LOADINGSTATE, { type: 'runInfo', loadingState: LoadingState.LOADED })
      // return rundetails
      return runDetails
    } catch (err) {
      // if an error occurs set LoadingState to Failed
      this.$store.dispatch(ACTIONS.SET_RUN_INFO_LOADINGSTATE, { type: 'runInfo', loadingState: LoadingState.FAILED })
      return err;
    }
  }

  async getCandidateStatus() {
    try {
      const candidates = await RunDetailsRestModel.getCandidateStatus();
      this.$store.dispatch(ACTIONS.SET_CANDIDATE_STATUS, candidates);
      return candidates;
    } catch (err) {
      return err;
    }
  }

  async getCandidateRuninformation() {
    this.$store.dispatch(ACTIONS.SET_RUN_INFO_LOADINGSTATE, { type: 'runInfo', loadingState: LoadingState.LOADING })
    try {
      const runInformation = await RunDetailsRestModel.getCandidateRunInfo();
      this.$store.dispatch(ACTIONS.SET_CANDIDATE_RUN_INFO, runInformation);
      this.$store.dispatch(ACTIONS.SET_RUN_INFO_LOADINGSTATE, { type: 'runInfo', loadingState: LoadingState.LOADED })
      return runInformation
    } catch (err) {
      this.$store.dispatch(ACTIONS.SET_RUN_INFO_LOADINGSTATE, { type: 'runInfo', loadingState: LoadingState.FAILED })
      return err;
    }
  }

  /**
   * @param {Array<string>} infoFragments
   */
  async getInfo(infoFragments) {
    const self = this;
    try {
      self.$store.dispatch(ACTIONS.SET_RUN_INFO_LOADINGSTATE, LoadingState.LOADING)
      // build query
      let query = '';
      if (Array.isArray(infoFragments) && infoFragments.length > 0) {
        query = `?expands=${infoFragments.join('&expands=')}`;
      }
      const info = await RunDetailsRestModel.getInfo(query);
      if (info) self.$store.dispatch(ACTIONS.SET_RUN_INFO, info);
      return info
    } catch (err) {
      return err;
    }
  }

  async getDocumentNames() {
    try {
      this.$store.dispatch(ACTIONS.SET_RUN_INFO_LOADINGSTATE, { type: 'runDocuments', payload: LoadingState.LOADING })
      const data = await RunDetailsRestModel.getDocumentNames();
      this.$store.dispatch(ACTIONS.SET_RUN_DOCUMENTS, data);
      return data;
    } catch (err) {
      console.error(err);
      return err;
    }
  }

  async getDocument(path) {
    try {
      const data = await RunDetailsRestModel.getDocument(path);
      return data
    } catch (err) {
      console.error(err);
      return err;
    }

  }
}
